// 這是Webpack掛載起始點
import Index from '../.components/index.vue'
import Edit from '../.components/edit.vue'
import New from '../.components/new.vue'

const main_router = 'roles';
const new_router = 'new_role';
const edit_router = 'edit_role';

const router = [
    {
        path: '/',
        component: Index,
        name: 'roles',
        meta: {
            api_name: "api_v1_provider_roles",
            breadcrumb: [main_router],
            btns: [new_router]
        }
    },
    {
        path: 'new',
        component: New,
        name: 'new_role',
        meta: {
            api_name: "api_v1_provider_role_create",
            breadcrumb: [main_router, new_router]
        }
    },
    {
        path: ':identity/edit',
        component: Edit,
        name: 'edit_role',
        meta: {
            api_name: "api_v1_provider_role_update",
            breadcrumb: [main_router, edit_router]
        }
    }
]


export default router;
